import {AxiosInstance} from "axios";
import PartnerRewardPointsMigrationDetails from "../model/partnerMigration/PartnerRewardPointsMigrationDetails";

/**
 * Api for migration of partner brand reward points migration to Xero.
 */
export default class MigrationApi {
	constructor(public readonly axiosInstance: AxiosInstance) {}

	runPartnerRewardPointsMigration(): Promise<any> {
		const url = `/api/web/accounting/run_migration`;
		return this.axiosInstance.post(url);
	}

	fetchMigrationStatusDetails() {
		const url = `/api/web/accounting/migration_status`;
		return this.axiosInstance.get(url).then(resp => PartnerRewardPointsMigrationDetails.fromJson(resp.data));
	}
}
